import React, { useRef, useEffect } from 'react'
import { CloseIcon, SearchIcon } from '../ui-components/Icons'
import useWindowSize from '../customHooks/useWindowSize'
import { Result } from '../types/types'

type Props = {
  handleSubmit: (e: React.SyntheticEvent) => void
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  searchValue: string
  setSearchTerms: React.Dispatch<React.SetStateAction<string>>
  setProducts: React.Dispatch<React.SetStateAction<Result[] | null>>
  setNoResults: React.Dispatch<React.SetStateAction<boolean>>
}

declare global {
  interface Window {
    openDrawer: () => void
    closeDrawer: () => void
    focusSearchInput: () => void
  }
}

function SearchBar({ handleSubmit, handleChange, searchValue, setSearchTerms, setProducts, setNoResults }: Props): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null)

  // Function to focus the input, which will be called from another file
  const focusInput = () => {
    inputRef.current?.focus()
  }

  useEffect(() => {
    window.focusSearchInput = focusInput
  }, [])

  const closeDrawer = () => {
    window.closeDrawer()
    setSearchTerms('')
    setProducts(null)
    setNoResults(false)
  }

  const windowSize = useWindowSize()
  const isMobile = windowSize.width <= 640

  return (
    <div className='mb-[16px] mx-5 md:mx-0 mt-5 md:mt-0 md:mb-[30px]'>
      <div className="border-neutral w-[350px] md:w-[712px] border-b-[0.5px] flex items-center">
        <SearchIcon isMobile={isMobile} />
        <form className="flex items-center w-full" onSubmit={handleSubmit}>
          <input
            id='ss-instant-search'
            ref={inputRef}
            className="text-base-2 input2 py-3 placeholder-inactive-state placeholder:tracking-[0.56px] text-black w-full ml-[10px]"
            name="q"
            placeholder="Enter Search Term"
            type="search"
            value={searchValue}
            onChange={handleChange}
          />
        </form>
        {isMobile && <CloseIcon isMobile={isMobile} onClick={closeDrawer} />}
      </div>
    </div>
  )
}

export default SearchBar